// This is a TypeGen auto-generated file. Changes will be lost when this file is regenerated.
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
export enum ContentType {
    Consent = 1,
    COI = 2,
    SecurityNotice = 3,
    SecurityDistributionStatement = 4,
    HomeSection1Member = 5,
    HomeSection2Member = 6,
    HomeSection3Member = 7,
    HomeSection1 = 8,
    HomeSection2 = 9,
    HomeSection3 = 10,
    PrivacyPolicy = 11,
}
